import React, { PureComponent } from 'react';
import Select from 'react-select';
import PropTypes from 'prop-types';

class SelectField extends PureComponent {

  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }

  state = {
    value: 3
  }

  componentDidMount () {
    this.setState({ value: this.props.defaultValue })
  }


  componentDidUpdate (prevProps, prevState) {
    if (this.props !== prevProps) {
      this.setState({ value: this.props.defaultValue })
    }
  }

  handleChange = (selectedOption) => {
    this.setState({ value: selectedOption })
    this.props.onChange(selectedOption);
  };

  render () {
    const { name } = this.props;

    return (
      <Select
        name={name}
        value={this.state.value}
        onChange={this.handleChange}
        options={this.props.options}
        className={'form__form-group-select' + this.props.className != null ? this.props.className : ''}
        placeholder={this.props.placeholder}
        clearable={this.props.clearable}
      />
    )
  }
}

const renderSelectField = (props) => {

  return <div className='form__form-group-input-wrap'>
    <SelectField
      {...props.input}
      options={props.options}
      defaultValue={props.defaultValue}
      clearable={props.clearable}
      className={props.className != null ? props.className : ''}
    />
    {props.meta.touched && props.meta.error && <span className='form__form-group-error'>{props.meta.error}</span>}
  </div>
};

renderSelectField.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object,
  options: PropTypes.array
};

export default renderSelectField;



// WEBPACK FOOTER //
// ./src/components/Select.js